import React from 'react'
import cls from './Flag.module.scss'

export function Flag({
  country_id = '',
  size = '',
  className = '',
  isAbsolute = true,
}: {
  country_id: any
  size: any
  className?: any
  isAbsolute?: boolean | null
}) {
  const initial_flag_size = 28
  const scale = size / initial_flag_size
  country_id = country_id || ''
  const flag_postfix = country_id.replace(/\s/g, '_')
  const isNotAbsolute = !isAbsolute ? cls.notAbsolute : null

  return (
    <span className={`${cls.flagContainer} ${isNotAbsolute}`} style={{ width: size, height: size }}>
      <i className={`${cls.flag} ${`flag_${flag_postfix}`}`} style={{ transform: `scale(${scale})` }} />
    </span>
  )
}
